import React from 'react';
import PropTypes from 'prop-types';
import { Table, Avatar } from 'antd';
import imageReservando from './../../images/ic_launcher.png';
import './styles.css';

const { Column } = Table;

const PromotionsTableAdmin = ({ data }) => {
    return (
        <Table className="promotionsTableAdminCont" dataSource={data} rowKey={record => (record.text + "_" + record.description)} size="small" pagination={false}>
            <Column className="categoryCont" title="Categoría" dataIndex="text" key="text" align="center" />
            <Column className="typeCont" title="Tipo" dataIndex="description" key="description" align="center" />
            <Column title="Icono" dataIndex="icon" key="icon" align="center"
                render={icon => (
                    <Avatar size={32} src={(icon && icon.url) ? icon.url : imageReservando} />
                )}
            />
            {/*<Column title="" dataIndex="delete" key="delete" align="center"
                render={(text, record) => (
                    <span>
                        {
                            record.isLoading ?
                                <Button type="primary" disabled={true} loading>
                                    Cargando
                                </Button>
                                :
                                <Popconfirm title="¿Desea borrar la promoción?" okText="SI" cancelText="NO" onConfirm={() => onDeletePromotion(record)}>
                                    <Button><DeleteOutlined /></Button>
                                </Popconfirm>
                        }
                    </span>
                )}
                    />*/}
        </Table>
    );
};

PromotionsTableAdmin.propTypes = {
    data: PropTypes.array,
    onActionSelected: PropTypes.func,
};

export default PromotionsTableAdmin;